import { render, staticRenderFns } from "./TabModeratorAchievementAchievementLevel.vue?vue&type=template&id=f7e07c2a&"
import script from "./TabModeratorAchievementAchievementLevel.vue?vue&type=script&lang=js&"
export * from "./TabModeratorAchievementAchievementLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
